module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.loading ? 'hide col-12' : 'col-12'
  }, [_c('div', {
    staticClass: "panel settings-page"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "fa fa-users icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('account.settings.team_section.tab_title')))]), _vm._v(" "), _c('div', {
    staticClass: "panel-actions"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("button.actions")) + "\n                  "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/new-user"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.add_a_new_user')) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.members.length > 0 && !_vm.loading),
      expression: "members.length > 0 && !loading"
    }],
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-responsive",
    attrs: {
      "id": "users-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.avatar')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.first_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.last_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('admin.index.users.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.members), function(member) {
    return _c('tr', [_c('td', [_c('img', {
      staticClass: "users-avatar img-responsive",
      attrs: {
        "src": member.avatar ? member.avatar : 'static/material/global/portraits/avatar.png'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.email))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "channel-change"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn btn-primary dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": '#/update-user/' + member.id
      }
    }, [_vm._v(_vm._s(_vm.$t("button.edit")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteTeamMember(member.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("admin.index.users.delete")))])])])])])])])
  }))])]), _vm._v(" "), (!_vm.loading && _vm.members.length === 0) ? _c('div', [_c('div', {
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("account.settings.team_section.team_members_not_found")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setupTeamMember()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.team_section.create_new_member")))])])])]) : _vm._e()])])])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28fa544f"}!./src/app/pages/account/team/team.html
// module id = 1355
// module chunks = 0